<template>
  <div class="p-4 md:p-6">
    <div class="justify-start text-xl text-primary">
      <span>
        {{ $t('message.table.movementInfo.comments') }}
      </span>
    </div>
    <ul
      class="overflow-y-scroll h-30"
      v-if="comments && comments.length"
    >
      <li
        v-for="comment in comments"
        :key="comment.id"
        class="flex flex-row w-full"
        :class="{ 'flex-row-reverse': currentUserComment(comment) }"
      >
        <div
          class="flex-grow p-2 my-2 rounded bg-sc-beige-light"
        >
          <div class="flex">
            <p class="mr-4 text-sm text-sc-gray">
              {{ `${comment.user.firstName} ${comment.user.lastName}` }}
            </p>
            <p class="flex-grow text-sm text-sc-gray">
              {{ comment.user.email }}
            </p>
            <button
              v-if="currentUserComment(comment)"
              class="flex-none text-sm underline text-secondary"
              @click="deleteComment(comment.id)"
            >
              <inline-svg
                :src="require('@assets/images/trash.svg')"
                class="w-5 fill-current text-secondary hover:text-sc-red -mt-1.5"
              />
            </button>
          </div>
          <p
            class="text-sm text-left whitespace-pre-line text-primary"
            v-html="comment.content"
          />
        </div>
        <div class="w-1/5 p-2 my-2 text-sm text-sc-gray">
          {{ comment.createdAt | dateTime }} hrs
        </div>
      </li>
    </ul>
    <div
      class="flex flex-col md:flex-row w-full"
    >
      <div class="w-full md:w-2/3 pt-2 pb-3">
        <b-field
          :type="!!error ? 'is-danger' : ''"
          class="w-full my-0 mr-3 leading-tight text-gray-700 bg-transparent border-none appearance-none focus:outline-none"
          :message="error&&error.message"
        >
          <b-input
            :placeholder="$t('message.table.movementInfo.commentPlaceholder')"
            type="textarea"
            v-model="newComment"
            @keyup.enter.native="handleEnter"
          />
        </b-field>
      </div>
      <div class="w-1/3 col-span-1 pt-2 md:pl-4 pr-2">
        <button
          @click="addComment"
          class="inline-block w-full py-3 text-sm leading-4 text-center text-white rounded bg-sc-blue hover:text-white focus:outline-none disabled:bg-sc-blue-lighter disabled:cursor-default"
          :disabled="!commentChanged"
        >
          {{ $t('message.table.movementInfo.commentButton') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      loading: null,
      error: null,
      newComment: '',
    };
  },
  computed: {
    comments() {
      return this.$store.state.movements.movementComments;
    },
    currentUser() {
      return this.$store.state.users.currentUser;
    },
    commentChanged() {
      return this.newComment !== '';
    },
  },
  props: {
    entityId: {
      type: Number,
      required: true,
    },
    movementId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    addComment() {
      this.$store.dispatch('addComment', { movementId: this.movementId, content: this.newComment });
      this.newComment = '';
    },
    currentUserComment(comment) {
      return comment.user.id === this.currentUser.id;
    },
    deleteComment(commentId) {
      this.$store.dispatch('deleteComment', { movementId: this.movementId, commentId });
    },
    handleEnter(event) {
      if (!event.shiftKey) {
        this.addComment();
      }
    },
  },
  mounted() {
    this.$store.dispatch('getComments', this.movementId);
  },
};
</script>
